export const Identifier = {
    CannotDeleteRecord: "cannotdeleterecord",
    ObjectDeleted: "objectdeleted",
    ObjectDeletedQueued: "objectdeletedqueued",
};

export default Identifier;
